export const getQty = (item) => {
  try {
    let type = item.weightType ? "Weight" : "Quantity";
    let quantity = item.weightType
      ? parseFloat(item.weight)
      : parseFloat(item.quantity);
    let itemQty =
      quantity % 1 === 0 ? quantity : parseFloat(quantity.toFixed(3));

    return { type, qty: itemQty };
  } catch (err) {
    console.log(err);
  }
};
